Astro.search = function() {
    var search = new Search();
    search.init();

    if (search.exists()) {
        Astro._search = search;
    }
}
